export default "__VITE_ASSET__0ec037be__"